import { InjectionToken } from '@angular/core';
import { ApiGridFilters, InitialState } from '@app/infrastructure/data-list/grid/api-grid-filters/api-grid-filters';
import { SortOrder } from '@app/infrastructure/data-list/grid/api-grid/api';
import { ApiGrid } from '@app/infrastructure/data-list/grid/api-grid/api-grid';
import { CommitmentListApiService } from '@modules/potential-save-modal/commitment-list/commitment-list-api.service';
import { ICommitmentDTO, ICommitmentFilters } from '@modules/potential-save-modal/commitment-list/commitment.model';

export const COMMITMENT_GRID_FILTER = new InjectionToken<ApiGridFilters<ICommitmentFilters>>(
	'filters for existing ri and sp',
);
export const COMMITMENT_GRID = new InjectionToken<ApiGrid<ICommitmentDTO, ICommitmentFilters>>(
	'api list for existing ri and sp',
);

export const COMMITMENT_DEFAULT_FILTERS: InitialState<ICommitmentFilters> = {
	filters: {
		is_supported: true,
	},
	sortColumn: {
		columnName: 'end',
		sortOrder: SortOrder.asc,
	},
};
const commitmentGridIdentity = (_: number, commitment: ICommitmentDTO): number => commitment?.rowId;

export const COMMITMENT_GRID_PROVIDERS = [
	CommitmentListApiService,
	{
		provide: COMMITMENT_GRID_FILTER,
		useFactory: ApiGridFilters.create<ICommitmentFilters>(COMMITMENT_DEFAULT_FILTERS),
	},
	{
		provide: COMMITMENT_GRID,
		useFactory: ApiGrid.create(commitmentGridIdentity),
		deps: [COMMITMENT_GRID_FILTER, CommitmentListApiService],
	},
];
